<script setup>
import { inject } from 'vue'
const props = defineProps(['percentage'])
const { pages } = inject('Shared')

</script>

<template lang="pug">
.stepProgressLineContainer.fu
  .box(:style="percentage >= 0 ? `background: ${pages.detailReport.potentialAnalysis.renovationPressureBackgroundLow};` : ''")
  .box(:style="percentage >= 10 ? `background: ${pages.detailReport.potentialAnalysis.renovationPressureBackgroundMedium};` : ''")
  .box(:style="percentage >= 20 ? `background: ${pages.detailReport.potentialAnalysis.renovationPressureBackgroundHigh};` : ''")
  .box(:style="percentage >= 30 ? `background: ${pages.detailReport.potentialAnalysis.renovationPressureBackgroundHigh};` : ''")
  .box(:style="percentage >= 40 ? `background: ${pages.detailReport.potentialAnalysis.renovationPressureBackgroundHigh};` : ''")
  .box(:style="percentage >= 50 ? `background: ${pages.detailReport.potentialAnalysis.renovationPressureBackgroundHigh};` : ''")
  .box(:style="percentage >= 60 ? `background: ${pages.detailReport.potentialAnalysis.renovationPressureBackgroundHigh};` : ''")
  .box(:style="percentage >= 70 ? `background: ${pages.detailReport.potentialAnalysis.renovationPressureBackgroundHigh};` : ''")
  .box(:style="percentage >= 80 ? `background: ${pages.detailReport.potentialAnalysis.renovationPressureBackgroundHigh};` : ''")
  .box(:style="percentage >= 90 ? `background: ${pages.detailReport.potentialAnalysis.renovationPressureBackgroundHigh};` : ''")
</template>

<style scoped lang="sass">
.stepProgressLineContainer
  display: flex
  flex-direction: row
  .box
    background: #DCE7F2
    border-radius: 2px
    margin-right: 2px
    @media screen and (min-width: 1024px)
      width: 19.81px
      height: 25px
    @media screen and (max-width: 1023px)
      width: 27px
      height: 35px
</style>
